// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"878b8dbf","239":"0446f75d","488":"3c8ed75f","667":"a2bc6c5b"}[chunkId] + ".chunk.js";
};